<template>
    <div>
        <form @submit.prevent class="d-flex flex-row" id="translations-manager-filters-container">
            <div>
                <label class="base-input__label">Languages</label>
                <el-select v-model="filters.languages" multiple>
                    <el-option
                        v-for="language in availableLanguages"
                        :key="language.value"
                        :value="language.value"
                        :label="language.label"
                    />
                </el-select>
            </div>

            <div>
                <label class="base-input__label">Words</label>
                <base-input
                    type="number"
                    v-model="filters.translatedWordsCount"
                />
            </div>
            <div>
                <label class="base-input__label">User</label>
                <base-input
                    type="text"
                    v-model="filters.email"
                />
            </div>
            <div>
                <label class="base-input__label">Status</label>
                <el-select v-model="filters.statuses" multiple>
                    <el-option
                        v-for="status in availableStatuses"
                        :key="status.value"
                        :value="status.value"
                        :label="formatStatus(status.value)"
                    />
                </el-select>
            </div>

            <div>
                <label class="base-input__label">Created on</label>
                <el-date-picker
                  v-model="filters.createdAt"
                  type="date"
                  clearable
                />
            </div>

            <div>
                <label class="base-input__label">Deadline</label>
                <el-date-picker
                  v-model="filters.deadline"
                  type="date"
                  clearable
                />
            </div>
        </form>
    </div>
</template>

<script>
import { DatePicker, Select, Option } from "element-ui"
import { BaseInput } from '@/components'
import { formatStatus } from "../Helpers/formatters";


export default {
    components: {
        [DatePicker.name]: DatePicker,
        [Select.name]: Select,
        [Option.name]: Option,
        BaseInput,
    },
    props: {
        /** @type {{label: string, value: string}[]} */
        availableStatuses: {
            type: Array,
            required: false,
            default: () => [],
        },
        /** @type {{label: string, value: string}[]} */
        availableLanguages: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
    data() {
        return {
            filters: {
                languages: null,
                translatedWordsCount: null,
                email: null,
                statuses: null,
                createdAt: null,
                deadline: null,
            },
        }
    },
    methods: {
        formatStatus,
    },
    watch: {
        filters: {
            deep: true,
            handler (newFilters) {
                this.$emit('change', newFilters)
            }
        }
    }
}
</script>

<style scoped>
.base-input__label {
    display: block !important;
}

#translations-manager-filters-container {
    gap: var(--gap, 10px);
}
</style>